import { useMemo } from "react";
import { MinimizedModalsTabsView } from "./components/MinimizedModalsTabsView";
import { getMinimizedModalLabel } from "./helpers/getMinimizedModalLabel";

type MinimizedModal = {
  id: string | number;
  key?: string;
  title?: string;
  label?: string;
  minimized?: boolean;
};

type MinimizedModalsTabsProps = {
  modals?: MinimizedModal[];
  expandItem?: boolean;
  closeModal: (id: MinimizedModal["id"]) => void;
  restoreModal: (id: MinimizedModal["id"]) => void;
  reorderModal: (sourceId: MinimizedModal["id"], targetId: MinimizedModal["id"]) => void;
  bringToFront: (id: MinimizedModal["id"]) => void;
};

export const MinimizedModalsTabs = ({
  modals = [],
  expandItem = true,
  closeModal,
  restoreModal,
  reorderModal,
  bringToFront,
}: MinimizedModalsTabsProps) => {
  const minimizedModals = useMemo(() => modals.filter((modal) => modal?.minimized), [modals]);
  const leftOffset = expandItem ? 292 : 112;

  const handleRestore = (modal: MinimizedModal) => {
    restoreModal(modal.id);
    bringToFront(modal.id);
  };

  return (
    <MinimizedModalsTabsView
      minimizedModals={minimizedModals}
      getLabel={getMinimizedModalLabel}
      onRestore={handleRestore}
      onClose={(modal) => closeModal(modal.id)}
      onReorder={reorderModal}
      leftOffset={leftOffset}
    />
  );
};
